import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _slicedToArray from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.function.name";
import _objectSpread from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
import { asyncRoutes, constantRoutes } from "@/router";
import { resolve } from "path";

/**
 * Use meta.role to determine if the current user has permission
 */
function hasMenuPermission(route, flatMenus, parentPath) {
  if (route && flatMenus) {
    var matchPath = resolve(parentPath, route.path);
    var matchAliasPath = route.serverAuthPath && resolve(parentPath, route.serverAuthPath);
    if (route.meta && route.meta.isAllow) {
      return route;
    }
    var matchItem = flatMenus.find(function (menu) {
      var menuPath = resolve(menu.path.toLocaleLowerCase());
      return matchPath.toLocaleLowerCase() === menuPath || matchAliasPath && menuPath === matchAliasPath.toLocaleLowerCase();
    });
    return matchItem;
  }
  return false;
}

/**
 * 扁平化菜单路由
 *
 * @export
 * @param {*} menus
 * @returns
 */
export function flatAuthMenus(menus) {
  var res = [];
  menus.forEach(function (item) {
    res.push(_objectSpread({}, item));
    if (item.children) {
      res = res.concat(flatAuthMenus(item.children));
    }
  });
  return res;
}

/**
 * 过滤出匹配菜单权限的路由
 *
 * @export
 * @param {*} routes
 * @param {*} flatMenus
 * @param {string} [parentPath=""]
 * @returns
 */
export function filterAuthMenuRoutes(routes, flatMenus) {
  var parentPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  try {
    var result = [];
    routes.map(function (route) {
      var o = _objectSpread({}, route);
      var matchMenu = hasMenuPermission(o, flatMenus, parentPath);
      if (matchMenu) {
        if (o.children) {
          var nextParentPath = resolve(parentPath, o.path);
          o.children = filterAuthMenuRoutes(o.children, flatMenus, nextParentPath);
        }
        // change icon from server data
        var _ref = matchMenu.meta || {},
          _ref$isAllow = _ref.isAllow,
          isAllow = _ref$isAllow === void 0 ? false : _ref$isAllow;
        !o.meta && (o.meta = {});
        if (!isAllow) {
          matchMenu.name && (o.title = o.meta.title = matchMenu.name);
          matchMenu.sort && (o.sort = matchMenu.sort);
        }
        o.meta.menuId = matchMenu.pageId;
        matchMenu.icon && (o.meta.icon = matchMenu.icon);
        result.push(o);
      }
    });
    return result;
  } catch (error) {
    console.log(error);
  }
}
export function sortTree(trees) {
  return trees.sort(function (f, s) {
    return f.sort - s.sort;
  }).map(function (item) {
    if (item.children && item.children.length > 0) {
      item.children = sortTree(item.children);
    }
    return item;
  });
}

/**
 * 判断是否存在首页路由
 *
 * @export
 * @param {*} accessedRoutes
 * @param {string} [homePath="/"]
 * @returns
 */
export function existHomePageMenuRoute(accessedRoutes) {
  var homePath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
  return !accessedRoutes.some(function (item) {
    return item.path === homePath;
  });
}

/**
 * list convert to Tree
 *
 * @export
 * @param {*} list
 * @returns
 */
export function listToTree(list) {
  var map = {};
  var tree = [];
  var node;
  var i;
  for (i = 0; i < list.length; i++) {
    map[list[i].id] = list[i];
    list[i].children = [];
  }
  for (i = 0; i < list.length; i += 1) {
    node = list[i];
    if (node.parentId !== "0") {
      map[node.parentId] && map[node.parentId].children.push(node);
    } else {
      tree.push(node);
    }
  }
  return tree;
}

/**
 * 根据id查找菜单树对应的子集权限
 *
 * @export
 * @param {*} id
 * @param {*} tree
 * @returns
 */
export function searchTreeWithId(id, tree) {
  var children = null;
  var _iterator = _createForOfIteratorHelper(tree),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var t = _step.value;
      if (t.id === id) {
        children = t.children;
        break;
      } else if (t.children && t.children.length > 0) {
        children = searchTreeWithId(id, t.children);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return children;
}

/**
 * 生成操作按钮的全路径编码
 * @export
 * @param {*} btnMenus
 * @param {*} allMenus
 * @returns
 */
export function generateOperationCode(btnMenus, allMenus) {
  var searchParent = function searchParent(parentId) {
    var codeList = [];
    if (!parentId) return codeList;
    var parentItem = allMenus.find(function (p) {
      return p.id === parentId;
    });
    if (parentItem) {
      if (parentItem.parentId && parentItem.parentId !== "0") {
        codeList.unshift.apply(codeList, _toConsumableArray(searchParent(parentItem.parentId)));
      }
      parentItem.code && codeList.push(parentItem.code);
    }
    return codeList;
  };
  return btnMenus.map(function (item) {
    var codes = searchParent(item.parentId);
    item.code && codes.push(item.code);
    item.fullCode = codes.join("-");
    return item;
  });
}
var state = {
  routes: [],
  treeMenus: {},
  operationButtons: [],
  addRoutes: [],
  sildeBarRoutes: []
};
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = constantRoutes.concat(routes);
  },
  SET_OPERATIONBUTTONS: function SET_OPERATIONBUTTONS(state, operation_permission) {
    state.operationButtons = operation_permission;
  },
  SET_TREEMENUS: function SET_TREEMENUS(state, treeMenus) {
    state.treeMenus = treeMenus;
  },
  SET_SILDEBAR_ROUTES: function SET_SILDEBAR_ROUTES(state, sildebarRoutes) {
    state.sildeBarRoutes = sildebarRoutes;
  }
};
var actions = {
  /**
   * 生成可访问的菜单路由
   *
   * @param {*} {commit}
   * @param {*} menus
   */
  generateMenuRoutes: function () {
    var _generateMenuRoutes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2, flatMenus) {
      var commit, state, menus, treeMenus, accessedRoutes, isExistHomeRoute, _accessedRoutes$filte, _accessedRoutes$filte2, _accessedRoutes$filte3, firstRoute;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref2.commit, state = _ref2.state;
            // const flatMenus = flatAuthMenus(menus)
            menus = flatMenus.filter(function (item) {
              return item.type === 1;
            });
            treeMenus = listToTree(flatMenus);
            accessedRoutes = filterAuthMenuRoutes(asyncRoutes, menus);
            accessedRoutes = sortTree(accessedRoutes);
            // const accessedRoutes = asyncRoutes
            if (accessedRoutes.length) {
              isExistHomeRoute = existHomePageMenuRoute(accessedRoutes); // not exist home path , use accessedRoutes first item add
              if (isExistHomeRoute) {
                _accessedRoutes$filte = accessedRoutes.filter(function (f) {
                  return !f.hidden;
                }), _accessedRoutes$filte2 = _slicedToArray(_accessedRoutes$filte, 1), _accessedRoutes$filte3 = _accessedRoutes$filte2[0], firstRoute = _accessedRoutes$filte3 === void 0 ? null : _accessedRoutes$filte3;
                firstRoute && accessedRoutes.unshift({
                  path: "/",
                  redirect: firstRoute.path
                });
              }
            }
            console.log("accessedRoutes", accessedRoutes);
            commit("SET_TREEMENUS", treeMenus);
            commit("SET_ROUTES", accessedRoutes);
            return _context.abrupt("return", state.routes);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function generateMenuRoutes(_x, _x2) {
      return _generateMenuRoutes.apply(this, arguments);
    }
    return generateMenuRoutes;
  }(),
  /**
   * 生成按钮级别的权限并存储(暂时不用)
   *
   * @param {*} { commit, state }
   * @param {*} menus
   */
  generateOperationPermission: function generateOperationPermission(_ref3, menus) {
    var commit = _ref3.commit,
      state = _ref3.state;
    var operationButtonList = menus.filter(function (menu) {
      return menu.type === 2;
    });
    operationButtonList = generateOperationCode(operationButtonList, menus);
    commit("SET_OPERATIONBUTTONS", operationButtonList);
    return state.operationButtons;
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};